(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('PacketRuleService', PacketRuleService);

    PacketRuleService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function PacketRuleService($http, $q, RequestService, ModalConstructor, AlertModalService) {

        var service = {
            // API Methods
            listPacketRule: listPacketRule,
            getTypeList: getTypeList,
            listGroups: listGroups,
            listTypes: listTypes,
            getPacketRule: getPacketRule,
            addPacketRule: addPacketRule,
            updatePacketRule: updatePacketRule,
            deletePacketRule: deletePacketRule,
            // Modal Methods
            successModalConstructor: successModalConstructor,
            errorModalConstructor: errorModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            addPacketRuleModalConstructor: addPacketRuleModalConstructor,
            editPacketRuleModalConstructor: editPacketRuleModalConstructor
        };

        return service;

        function listPacketRule(filters) {
            var expressionFilter = constructFilter(filters || {});
            return $http.get(apiUrl(), {params: expressionFilter, ignoreLoadingBar: true}).then(responseData);
        }

        function getTypeList() {
            return $q.resolve([
                {label: 'ACL Allow', value: 'allow'},
                {label: 'DHCP Relay', value: 'bridgedhcprelay'},
                {label: 'Forbid OUI', value: 'bridgeforbidoui'},
                {label: 'Insert OptionDhcpV4Relay ', value: 'bridgeinsertdhcpv4relayoptions'},
                {label: 'Insert OptionDhcpV6Relay', value: 'bridgeinsertdhcpv6relayoptions'},
                {label: 'Insert Option82', value: 'bridgeinsertoption82'},
                {label: 'Insert PPPoE Vendor Tag', value: 'bridgeinsertpppoevendortag'},
                {label: 'Bridge Storm Detection', value: 'bridgestormdetect'},
                {label: 'Color Aware Rate Limit Discard', value: 'colorawareratelimitdiscard'},
                {label: 'ACL Deny', value: 'deny'},
                {label: 'DSCP To CoS', value: 'dscptocos'},
                {label: 'Destination MAC Swap Dynamic ', value: 'dstmacswapdynamic'},
                {label: 'Destination MAC Swap Static', value: 'dstmacswapstatic'},
                {label: 'Filter First Encapsulation VLAN', value: 'filterfirstencapsulationvlan'},
                {label: 'Promote First Encapsulation VLAN', value: 'promotefirstencapsulationvlan'},
                {label: 'Rate Limit Discard', value: 'ratelimitdiscard'},
                {label: 'Access List', value: 'accesslist'},
                {label: 'Storm Control', value: 'stormcontrol'},
            ]);
        }

        function listGroups(oltId, hideLoader) {
            return $http
                    .get(apiUrl(oltId + '/groups'), {ignoreLoadingBar: !!hideLoader})
                    .then(function (response) {
                        if (response.data.length) {
                            response.data.unshift({id: null, groupIdEquipment: null});
                        }
                        return response.data;
                    });
        }

        function listTypes(oltId) {
            return $http.get(apiUrl(oltId + '/types')).then(responseData);
        }

        function getPacketRule(packetRuleId) {
            return $http.get(apiUrl(packetRuleId)).then(responseData);
        }

        function addPacketRule(data) {
            return $http.post(apiUrl(), data).then(responseData);
        }

        function updatePacketRule(data) {
            return $http.put(apiUrl(), data).then(responseData);
        }

        function deletePacketRule(packetRuleData) {
            return $http.delete(apiUrl(packetRuleData.id)).then(responseData);
        }

        // Helper Functions
        function apiUrl(method) {
            return RequestService.apiUrl('packetrules/', method);
        }

        function constructFilter(filter) {
            var result = {oltId: null};
            if (filter.oltId) {
                result.oltId = filter.oltId;
            }
            return result;
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        // Modal Methods
        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'packetRules');
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'packetRules');
        }

        function confirmationModalConstructor(packetRuleData, dataAction) {
            var confirm = {
                templateUrl: 'app/components/packet-rule/packet-rule-confirm.html',
                controller: 'PacketRuleConfirmController',
                controllerAs: 'vmPacketRulesConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    packetRuleItem: function () {
                        return packetRuleData
                    }
                }
            };
            ModalConstructor.open(confirm);
        }

        function addPacketRuleModalConstructor(scope) {
            var modal = packetRulesModalConfig();
            ModalConstructor.open(modal);
        }

        function editPacketRuleModalConstructor(packetRuleId, scope) {
            var modal = packetRulesModalConfig();
            modal.scope = scope;
            modal.resolve.packetRuleId = packetRuleId;
            ModalConstructor.open(modal);
        }

        function packetRulesModalConfig() {
            return {
                templateUrl: 'app/components/packet-rule/packet-rule-add.html',
                controller: 'PacketRuleAddController',
                controllerAs: 'vmPacketRuleAdd',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    packetRuleId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('packet-rule');
                            return $translate.refresh();
                        }]
                }
            };
        }

    }

})();